document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hero-banner').forEach(function (banner) {
    var slides = Array.prototype.slice.call(banner.querySelectorAll('.hero-banner__slide'));
    var dots = Array.prototype.slice.call(banner.querySelectorAll('.hero-banner__dot'));
    var prevBtn = banner.querySelector('.hero-banner__arrow--prev');
    var nextBtn = banner.querySelector('.hero-banner__arrow--next');

    // Some mobile browsers silently ignore the native `autoplay` HTML attribute
    // depending on how the file was encoded or on connection speed. Explicitly
    // calling .play() as a fallback is more reliable, especially on iOS Safari.
    // The muted/playsinline properties are also set here (not just as HTML
    // attributes) because a few WebKit versions only honor the JS property.
    function attemptPlay(video) {
      if (!video) return;
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // Autoplay was blocked (e.g. Low Power Mode, or a per-site Safari
          // Auto-Play setting). Retry once the video has enough data buffered,
          // and again on first user interaction with the page as a last resort.
          video.addEventListener('canplaythrough', function retryOnReady() {
            video.play().catch(function () {});
            video.removeEventListener('canplaythrough', retryOnReady);
          });
          var retryOnInteraction = function () {
            video.play().catch(function () {});
            document.removeEventListener('touchstart', retryOnInteraction);
            document.removeEventListener('click', retryOnInteraction);
          };
          document.addEventListener('touchstart', retryOnInteraction, { once: true });
          document.addEventListener('click', retryOnInteraction, { once: true });
        });
      }
    }

    banner.querySelectorAll('.hero-banner__slide.is-active .hero-banner__video').forEach(attemptPlay);

    // Sound toggle buttons: each sits outside its slide's link, so clicking it
    // never triggers navigation. It just flips the muted property on that
    // slide's video and swaps the icon/aria state.
    banner.querySelectorAll('.hero-banner__sound-toggle').forEach(function (btn) {
      var slide = btn.closest('.hero-banner__slide');
      var video = slide ? slide.querySelector('.hero-banner__video') : null;
      if (!video) return;

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        video.muted = !video.muted;
        var isUnmuted = !video.muted;
        btn.classList.toggle('is-unmuted', isUnmuted);
        btn.setAttribute('aria-pressed', isUnmuted ? 'true' : 'false');
        btn.setAttribute('aria-label', isUnmuted ? 'Turn sound off' : 'Turn sound on');
      });
    });

    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = banner.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(banner.getAttribute('data-speed'), 10) || 6000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
      var video = slides[current].querySelector('.hero-banner__video');
      if (video) attemptPlay(video);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    banner.addEventListener('mouseenter', stopAutoplay);
    banner.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});
